
import React, { Component } from 'react';
// import './site-styles/template_styles.local-copy.css';
// import './site-styles/main.f4852b53.local-copy.css';

import Input from './components/input';
import Range from './components/range';
import Results from './components/results';

//import formatMoney from './helpers/format-money/'
import formatYears from './helpers/format-years/'
// import SiteStyles from './components/siteStyles/'

// import './App.css'; // !!!!!!! это файл подключается только во время работы в dev режиме над калькулятором! и перед билдом комментируется!!!
import './newsStyle.css';

// const NODE_ENV = process.env.NODE_ENV;
// console.log('NODE_ENV = ',NODE_ENV);

class App extends Component {
  constructor(props){
    super(props);

    //const { credits } = window.__DATA__;

    /* API URL */
    let apiUrl = document.getElementById('root').getAttribute('data-api-url');
    if (!apiUrl) { console.error('API URL is not defined as "data-api-url" attribute in "#root".'); }
    let emojiUrl = document.getElementById('emoji').getAttribute('data-emoji') || null;
    if (!emojiUrl) { console.error('API URL is not defined as "data-emoji" attribute in "#emoji".'); }

    let credits = [];
    // let citizenshipList = [];
    let programList = ['Все программы'];
    let firstFeePercentArray = [];
    let creditMinLengthArray = [];

    // this.getDataFromServer(apiUrl, data => {
    this.getDataFromServerNew(apiUrl, data => {
      data.data.forEach((credit, i) => {
        // const availableCitizenship = this.getCitizenshipList(credit.citizenships);
        const availableProgram = this.getProgramList(credit.mortgagePrograms);

        credits.push({
          title: credit.bank.name,
          // availableCitizenship: availableCitizenship,
          availableProgram: availableProgram,
          // age: {
          //   min: credit.age_min,
          //   max: credit.age_max
          // },
          creditLength: {
            min: credit.credit_term_min,
            max: credit.credit_term_max
          },
          maxSum: credit.max_summ,
          percent: credit.percent,
          minFirstFeePercent: credit.initial_fee_min_percent,
          img: credit.bank.image,

          imgWhite: credit.bank.white_image,
          backgroundColor: credit.bank.background_color,

          // subsidizing: credit.is_subsidizing,
          subsidizingSupport: credit.is_subsidizing,
          mortgagePrograms: credit.mortgagePrograms,
          disclaimer: credit.disclaimer,
          
          stateSupport: credit.is_state_support,
          // id: i
          id: credit.bank.id
        });

        // availableCitizenship.forEach(citizenship => {
        //   if (citizenshipList.indexOf(citizenship) === -1){
        //     citizenshipList.push(citizenship)
        //   }
        // });

        availableProgram.forEach(program => {
          if (programList.indexOf(program) === -1){
            programList.push(program)
          }
        });
      });

      credits.forEach(credit => {
        if (credit.creditLength.max > defaultProps.creditLengthMax){
          defaultProps.creditLengthMax = credit.creditLength.max
        }
        // if (credit.age.max > defaultProps.ageMax){
        //   defaultProps.ageMax = credit.age.max
        // }

        firstFeePercentArray.push(credit.minFirstFeePercent);
        creditMinLengthArray.push(credit.creditLength.min)
      });

      this.setState({
        credits: credits,
        // citizenshipList: citizenshipList,
        programList: programList,
        // subsidizingList: subsidizingList,
        mostFrequentFirstFeePercent: this.findMostFrequentInArray(firstFeePercentArray),
        mostFrequentMinCreditLength: this.findMostFrequentInArray(creditMinLengthArray),
      })
    }, 'ru');

    const urlData = this.parseURL(window.location.href);


    let defaultProps = {
      maxPrice: 200000000,
      creditSum: urlData && urlData.creditSum ? urlData.creditSum : 37000000,

      creditLengthMin: 0,
      creditLengthMax: 30,

      // ageMin: 18,
      // ageMax: 80,
      // age: 30,

      credits: credits,

      firstFeePercent: 20,
      maxFirstFeePercent: 90,

      citizenship: 'РФ',

      program: 'Все программы',
      programAll: 'Все программы',

      stateSupport: 0,
      subsidizingSupport: 0,

      email: '',
      emojiUrl:emojiUrl,
    };

    defaultProps.firstFee = defaultProps.creditSum / 100 * defaultProps.firstFeePercent;
    defaultProps.maxFirstFee = Math.round(defaultProps.creditSum / 100 * defaultProps.maxFirstFeePercent);

    defaultProps.creditLength = Math.floor((defaultProps.creditLengthMax + defaultProps.creditLengthMin) / 2);

    this.state = defaultProps;
  };

  getDataFromServer = (url, callback, lang) => {
    const httpRequest = new XMLHttpRequest();

    httpRequest.onreadystatechange = () => {
      if (httpRequest.readyState === 4 && httpRequest.status === 200){
        callback(JSON.parse(httpRequest.responseText));
      }
    };

    httpRequest.open('get', url, true);
    httpRequest.setRequestHeader('Accept-Language', lang);
    httpRequest.send();
  };

  getDataFromServerNew = async (url, callback, lang) => {
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Accept-Language': lang,
        }
      });
      const res = await response.json();
      let nextLink = res.links.next ? res.links.next : false;

      while (nextLink) {
          const responseCustom = await fetch(res.links.next,{
            method: 'GET',
            headers: {
              'Accept-Language': lang,
            }
          });
          const resCustom = await responseCustom.json();

          nextLink = resCustom.data.next ? resCustom.data.next : false;
          
          res.data.push(...resCustom.data)
          res.links = resCustom.links;
          res.meta = resCustom.meta;
      }

      callback(res);
    } catch (error) {
      console.log(error)
    }
  };

  parseURL = (url) => {
    const data = {};

    url = url.slice(url.indexOf('?') + 1, url.length + 1).split('&');

    url.forEach(item => {
      item = item.split('=');
      data[item[0]] = Number(item[1])
    });

    return data;
  };

  // getCitizenshipList = (arr) => {
  //   let citizenshipList = [];
  //   arr.forEach(item => {
  //     citizenshipList.push(item.name)
  //   });
  //   return citizenshipList
  // };
  
  getProgramList = (arr) => {
    let programList = [];
    arr.forEach(item => {
      programList.push(item.name)
    });
    return programList
  };

  // getSubsidizingList = (arr) => {
  //   let subsidizingList = [];
  //   arr.forEach(item => {
  //     subsidizingList.push(item.name)
  //   });
  //   return subsidizingList
  // };

  findMostFrequentInArray = (array) => {
    if (!array.length) return;
    let reduced = array.reduce((reduced, number) => {
      if (number in reduced){
        reduced[number]++;
      } else {
        reduced[number] = 1;
      }

      return reduced;
    }, {});

    return Object.keys(reduced).reduce((a, b) => reduced[a] >= reduced[b] ? a : b)
  };

  handleChange = (prop, value) => {
    // console.log('handleChange prop = ', prop);
    // console.log('handleChange value = ', value);
    if (typeof(value) === 'object'){
      value = value.target.value
    }
    this.setState({
      [prop]: value
    })
  };

  handleSelectChange = (prop, {value}) => {
    // console.log('handleSelectChange prop = ', prop);
    // console.log('handleSelectChange value = ', value);
    if (typeof(value) === 'object'){
      value = value.target.value
    }
    this.setState({
      [prop]: value
    })
  };

  changeFirstFee = value => {
    this.setState({
      firstFee: value,
      firstFeePercent: this.calcFirstFeePercent()
    });
  };

  changeCreditSum = value => {
    if (value < Math.round(this.state.firstFee / 9 * 10)){
      this.setState({
        firstFee: this.calcMaxFirstFee(value)
      })
    };
    this.setState({
      creditSum: value,
      maxFirstFee: this.calcMaxFirstFee(value),
      firstFeePercent: this.calcFirstFeePercent(),
    })
  };

  changeSubsidizingSupport = value => {
    this.setState({
      subsidizingSupport: value,
    });
  };

  calcMaxFirstFee = value => Math.round(value / 10 * 9);

  calcFirstFeePercent = () => {
    const result = Math.round(this.state.firstFee / (this.state.creditSum / 100));
    return isNaN(result) || result === Infinity ? 0 : result
  };


  banksListTransform = (banksList) => {
    let newBanksList = banksList.map((item => {
      const { id, title, img, imgWhite, backgroundColor, ...rest } = item;
      
      return ({
        id,
        name: title,
        image: img,
        imageWhite: imgWhite,
        backgroundColor: backgroundColor,
        ...rest,
      })
    }));
    
    const prepare = (arr) => {
      const newArr = [];
    
      arr.forEach(obj1 => {
        const { id, name, image, imageWhite, backgroundColor, ...rest } = obj1;
    
        const found = newArr.find((obj2) => obj1.id === obj2.id);
        const foundIndex = newArr.findIndex((obj2) => obj1.id === obj2.id);
    
        if(found) {
          newArr[foundIndex].spisok = [...newArr[foundIndex].spisok,{
            ...rest
          }];
    
          return;
        } else {
          newArr.push({
            id,
            name,
            image,
            imageWhite,
            backgroundColor,
            spisok: [{
              ...rest
            }]
          })
        }
      });
    
      return newArr;
    }
    
    const prepared = prepare(newBanksList);
    return prepared;
  }


  filterCredits = () => {
    const formData = this.state;
    //let { credits } = window.__DATA__;
    let { credits } = this.state;
    let disabledCredits = [];

    credits = credits.filter(credit => {
      if (
        // credit.availableCitizenship.indexOf(formData.citizenship) !== -1 &&
        ((formData.programAll === formData.program) ? credit.availableProgram : credit.availableProgram.indexOf(formData.program) !== -1 )
        // ((formData.programAll === formData.program) ? credit.availableProgram : credit.availableProgram.indexOf(formData.program) !== -1 ) &&
        // credit.age.min <= formData.age &&
        // credit.age.max >= formData.age
      ){
        if (
          credit.creditLength.min <= formData.creditLength &&
          credit.creditLength.max >=  formData.creditLength &&
          ((!isNaN(+credit.maxSum) && +credit.maxSum  >= (formData.creditSum - formData.firstFee) ) || credit.maxSum==null || credit.maxSum==='неограничена') &&
          credit.minFirstFeePercent <= formData.firstFeePercent
        ){
          if(formData.subsidizingSupport) {
            return (Boolean(credit.subsidizingSupport) === true)
          } else {
            return credit
          }
        } else {
          disabledCredits.push(credit);
          return null
        }
      } else return null
    });


    let smallestPercent = Infinity;

    credits.forEach(credit => {
      const percentPerMonth = credit.percent / 100 / 12;
      const monthsToPay = formData.creditLength * 12;
      const creditTotal = formData.creditSum - formData.firstFee;

      credit.payPerMonth = this.calculatePayPerMonth(percentPerMonth, monthsToPay, creditTotal);

      if (credit.percent < smallestPercent){
        smallestPercent = credit.percent;
      }
    });

    // let bestCredits = [];
    // let otherCredits = [];

    // credits.forEach(credit => {
    //   if (credit.percent === smallestPercent){
    //     bestCredits.push(credit);
    //   } else {
    //     otherCredits.push(credit);
    //   }
    // });

    // if (otherCredits.length){
    //   this.sortArr(otherCredits, 'percent')
    // }

    if (credits.length){
      this.sortArr(credits, 'payPerMonth');
    }

    if (disabledCredits.length){
      this.sortArr(disabledCredits, 'minFirstFeePercent');
      disabledCredits = disabledCredits.slice(0, 3);
    }

    return {
      best: credits,
      newBest: this.banksListTransform(credits),
      other: [],
      disabled: disabledCredits
    }
  };

  calculatePayPerMonth = (percentPerMonth, monthsToPay, creditSum) => {
    const presentValueInterestFactor = Math.pow(1 + percentPerMonth, monthsToPay);
    return percentPerMonth / (presentValueInterestFactor - 1) * creditSum * presentValueInterestFactor;
  };

  sortArr = (arr, prop) => {
    return arr.sort((a, b) => {
      return a[prop] - b[prop]
    });
  };

  renderPreloader = () => {
    return (
      <div className="preloader">
        <div className="preloader__wrapper">
          <div className="preloader__spinner"></div>
        </div>
      </div>
    )
  };

  getProperScrollDestination = (dest) => dest - 0;

  componentDidMount = () => {
    this.setState({
      scrollButtonAlternativeFlag: false
    });

    document.addEventListener('scroll', () => {
      if (this.refs.results.getBoundingClientRect().top <= 0){
        this.setState({
          scrollButtonAlternativeFlag: true
        })
      } else {
        this.setState({
          scrollButtonAlternativeFlag: false
        })
      }
    })
  };

  handleScroll = () => {
    const { scrollButtonAlternativeFlag } = this.state;
    const { results, calctitle } = this.refs;
    window.scroll({
      top: scrollButtonAlternativeFlag ? calctitle.getBoundingClientRect().top + window.pageYOffset - 20 : results.getBoundingClientRect().top + window.pageYOffset,
      behavior: 'smooth'
    })
  };

  handlePick = (credit) => {
    this.setState({
      pickedCredit: credit
    })
  };

  openModal = () => {
    this.setState({
      modalOpenFlag: true
    })
  };

  closeModal = () => {
    this.setState({
      modalOpenFlag: false
    })
  };

  handleSubmit = (pickedCredit) => {
    //alert(JSON.stringify(pickedCredit))
    this.setState({
      sending: true
    });
    setTimeout(() => {
      this.setState({
        sending: false,
        sendSuccess: true
      });
    }, 1000);
  };

  hideBanner = () => {
    this.setState({
      sendSuccess: false
    })
  };

  checkIfPickedCreditInResults = (results, pickedCredit) => results.indexOf(pickedCredit) !== -1 ? true : false;

  render() {

    const {
      credits,
      // citizenshipList,
      // subsidizingList,
      programList,

      subsidizingSupport,
      creditSum,
      maxPrice,
      firstFee, maxFirstFee, firstFeePercent, mostFrequentFirstFeePercent,
      // age, ageMin, ageMax,
      creditLength, creditLengthMax, creditLengthMin, mostFrequentMinCreditLength,
      pickedCredit,
      modalOpenFlag,
      email,
      scrollButtonAlternativeFlag,
      emojiUrl
    } = this.state;

    // console.log('this.state',this.state);
    if (!credits.length){
      return this.renderPreloader();
    }

    const results = this.filterCredits();

    return (
      <div className="app" ref="app">
        {/* {NODE_ENV === 'development' ? (
          <SiteStyles/>
        ) : null} */}
        <div className="center-wrapper">
          <h2 ref="calctitle">Ипотечный калькулятор</h2>
          <div className="col-wrapper">
            <div className="col col--left">
              <h3>Ипотечные программы</h3>
              <form className="form" onSubmit={(e) => {e.preventDefault(); this.openModal()}}>
                <Input
                  type="select"
                  // label="Все программы"
                  label=""
                  value={programList}
                  onChange={this.handleChange.bind(this, 'program')}
                  // onChange={this.handleSelectChange.bind(this, 'program')}
                />
                {/* <Input
                  type="select"
                  label="Гражданство"
                  // value={citizenshipList}
                  onChange={this.handleChange.bind(this, 'citizenship')}
                  // onChange={this.handleSelectChange.bind(this, 'citizenship')}
                /> */}
                {/* <MyComponent/> */}
                <Input
                  type="checkbox"
                  label="Субсидирование"
                  // value={this.state.subsidizingSupport}
                  // onChange={this.handleChange.bind(this, 'subsidizing')}
                  value={subsidizingSupport}
                  onChange={this.changeSubsidizingSupport.bind(this,!subsidizingSupport)}
                />
                {/* subsidizingSupport = {subsidizingSupport ? 'true' : 'false'} */}
                {/* <Range
                  label="Возраст заемщика, лет."
                  value={age}
                  min={ageMin}
                  max={ageMax}
                  onChange={this.handleChange.bind(this, 'age')}
                /> */}
                <Range
                  label="Стоимость квартиры, руб."
                  value={creditSum}
                  min={0}
                  max={maxPrice}
                  onChange={this.changeCreditSum.bind(this)}
                  isMoney={true}
                />
                <Range
                  label="Первоначальный взнос, руб."
                  value={firstFee}
                  min={0}
                  max={maxFirstFee}
                  onChange={this.changeFirstFee.bind(this)}
                  isMoney={true}
                  note={`${this.calcFirstFeePercent()}%`}
                  tip={
                    firstFeePercent < mostFrequentFirstFeePercent &&
                    `У большинства кредитов первоначальный взнос более ${mostFrequentFirstFeePercent}%`
                  }
                  error={ firstFeePercent < mostFrequentFirstFeePercent }
                />
                <Range
                  label="Срок кредита, лет"
                  value={creditLength}
                  min={creditLengthMin}
                  max={creditLengthMax}
                  onChange={this.handleChange.bind(this, 'creditLength')}
                  tip={
                    creditLength < mostFrequentMinCreditLength &&
                    `У большинства кредитов минимальный срок: ${formatYears(mostFrequentMinCreditLength)}`
                  }
                  error={ creditLength < mostFrequentMinCreditLength }
                />
                {/*<div className="calculation">
                  <span className="calculation__title">Сумма кредита: </span>
                  <span className="calculation__value">
                    {formatMoney(true).to(creditSum - firstFee)}
                  </span>
                </div>*/}

                {this.checkIfPickedCreditInResults([...results.best, ...results.other], pickedCredit) && (
                  <input
                    type="submit"
                    value="Отправить на почту"
                    className="button"
                  />
                )}
                <button
                  type="button"
                  className={'scroll-button' + (
                    scrollButtonAlternativeFlag ? ' scroll-button--active' : ''
                  )}
                  onClick={this.handleScroll}
                >
                  {scrollButtonAlternativeFlag ? 'Вернуться наверх' : 'Перейти к результатам'}
                </button>
                
                {/* <div className="disclaim disclaim--desktop">
                  <p><span className={'disclaim-star'}>*</span> В рамках программы «Ипотека с господдержкой 2020» ставка в размере 4,3% действует в течение 6 месяцев, ставка 5,3% действует в течение  12 месяцев с даты заключения кредитного договора в случае оформления полного комплексного страхования и первоначальном взносе не менее 15%.</p>
                  <p>По окончанию указанного периода ставка составит 6,5% при оформлении комплексного страхования.  Заемщики - граждане РФ. Программа распространяется на покупку строящегося жилья у юридического лица (за исключением инвестиционного фонда, в том числе его управляющей компании) и готового жилья по договору купли-продажи у застройщика. Сумма кредита для Москвы, Московской области, Санкт-Петербурга и Ленинградской области - не более 12 млн. руб., для остальных регионов – не более 6 млн. руб. Валюта кредита – рубли. Срок кредита – от 1 до 30 лет. Срок заключения кредитного договора до 01.07.2021 (включительно).</p>
                  <p>Условия действительны на 25.05.2021 г.</p>
                  <p>Банк ВТБ (ПАО) оказывает исключительно банковские услуги. Банк вправе отказать в предоставлении кредита без объяснения причин. Банк предоставляет кредит в случае, если заемщик (созаемщик/поручитель, при наличии) соответствует требованиям госпрограммы и Банка и предоставил полный пакет необходимых документов.</p>
                  <p>Банк ВТБ (ПАО). Генеральная лицензия Банка России №1000. </p>
                </div> */}
              </form>
            </div>
            <div className="col col--right" ref="results">
              <Results
                credits={results}
                handlePick={this.handlePick}
                pickedCredit={pickedCredit}
                emoji={emojiUrl}
              />

                {/* <div className="disclaim disclaim--mobile">
                  <p><span className={'disclaim-star'}>*</span> В рамках программы «Ипотека с господдержкой 2020» ставка в размере 4,3% действует в течение 6 месяцев, ставка 5,3% действует в течение  12 месяцев с даты заключения кредитного договора в случае оформления полного комплексного страхования и первоначальном взносе не менее 15%.</p>
                  <p>По окончанию указанного периода ставка составит 6,5% при оформлении комплексного страхования.  Заемщики - граждане РФ. Программа распространяется на покупку строящегося жилья у юридического лица (за исключением инвестиционного фонда, в том числе его управляющей компании) и готового жилья по договору купли-продажи у застройщика. Сумма кредита для Москвы, Московской области, Санкт-Петербурга и Ленинградской области - не более 12 млн. руб., для остальных регионов – не более 6 млн. руб. Валюта кредита – рубли. Срок кредита – от 1 до 30 лет. Срок заключения кредитного договора до 01.07.2021 (включительно).</p>
                  <p>Условия действительны на 25.05.2021 г.</p>
                  <p>Банк ВТБ (ПАО) оказывает исключительно банковские услуги. Банк вправе отказать в предоставлении кредита без объяснения причин. Банк предоставляет кредит в случае, если заемщик (созаемщик/поручитель, при наличии) соответствует требованиям госпрограммы и Банка и предоставил полный пакет необходимых документов.</p>
                  <p>Банк ВТБ (ПАО). Генеральная лицензия Банка России №1000. </p>
                </div> */}
            </div>
          </div>
        </div>

        {modalOpenFlag && (
          <div className="modal" onClick={this.closeModal}>
            <div className="modal__body" onClick={(e) => {e.stopPropagation()}}>
              {this.state.sendSuccess ? (
                <React.Fragment>
                  <div className="banner">
                    <div className="banner-logo"></div>
                    <div>Отправлено успешно</div>
                  </div>
                  <button className="button" onClick={this.hideBanner}>Ок</button>
                </React.Fragment>
              ) : (
                this.state.sending ? (
                  this.renderPreloader()
                ) : (
                  <form onSubmit={(e) => {e.preventDefault(); this.handleSubmit(pickedCredit)}}>
                    <Input
                      type="email"
                      label="Введите адрес электронной почты, на который нужно отправить данные по выбранному предложению:"
                      value={email}
                      onChange={this.handleChange.bind(this, 'email')}
                      required={false}
                    />
                    <Input
                      type="submit"
                      value="Отправить"
                    />
                  </form>
                )
              )}
              <button className="modal__close" onClick={this.closeModal} />
            </div>
          </div>
        )}

        <div className='no-aferta'>Размещенные данные носят информационный характер и не являются публичной офертой. Подробную информацию об условиях предоставления ипотеки вы можете узнать по телефону.</div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js